import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function GraduationExamSetup() {
  const [classLevel, setClassLevel] = useState(11);
  const [language, setLanguage] = useState('english');
  const navigate = useNavigate();

  const handleStartExam = () => {
    // Перенаправляем на страницу мульти-теста, передавая класс и язык
    navigate(`/composite-test/${classLevel}/${language}`);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4 font-sans">
      <div className="max-w-xl w-full bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-slate-100">
        
        <div className="text-center mb-10">
          <div className="w-20 h-20 bg-purple-100 text-purple-600 rounded-3xl flex items-center justify-center text-4xl mx-auto mb-6 shadow-sm">
            🎓
          </div>
          <h1 className="text-3xl font-black text-slate-900 mb-3">Выпускной экзамен</h1>
          <p className="text-slate-500 font-medium">Настройте параметры экзамена перед началом тестирования.</p>
        </div>

        <div className="space-y-8">
          {/* Выбор класса */}
          <div>
            <label className="block text-sm font-black text-slate-700 uppercase tracking-widest mb-4">
              Выберите класс
            </label>
            <div className="grid grid-cols-2 gap-4">
              <button 
                onClick={() => setClassLevel(9)}
                className={`py-4 rounded-xl font-bold text-lg border-2 transition-all ${classLevel === 9 ? 'border-purple-600 bg-purple-50 text-purple-700' : 'border-slate-100 bg-white text-slate-500 hover:border-purple-200'}`}
              >
                9 класс
              </button>
              <button 
                onClick={() => setClassLevel(11)}
                className={`py-4 rounded-xl font-bold text-lg border-2 transition-all ${classLevel === 11 ? 'border-purple-600 bg-purple-50 text-purple-700' : 'border-slate-100 bg-white text-slate-500 hover:border-purple-200'}`}
              >
                11 класс
              </button>
            </div>
          </div>

          {/* Выбор языка */}
          <div>
            <label className="block text-sm font-black text-slate-700 uppercase tracking-widest mb-4">
              Иностранный язык (30 вопросов)
            </label>
            <div className="space-y-3">
              {[
                { id: 'english', icon: '🇬🇧', label: 'Английский язык' },
                { id: 'german', icon: '🇩🇪', label: 'Немецкий язык' },
                { id: 'french', icon: '🇫🇷', label: 'Французский язык' }
              ].map(lang => (
                <button 
                  key={lang.id}
                  onClick={() => setLanguage(lang.id)}
                  className={`w-full flex items-center p-4 rounded-xl font-bold border-2 transition-all ${language === lang.id ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-slate-100 bg-white text-slate-600 hover:border-blue-200'}`}
                >
                  <span className="text-2xl mr-4">{lang.icon}</span>
                  <span className="text-lg">{lang.label}</span>
                  {language === lang.id && <span className="ml-auto text-blue-600 text-xl">✓</span>}
                </button>
              ))}
            </div>
          </div>

          {/* Информация о структуре */}
          <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100">
            <h4 className="text-xs font-black text-slate-400 uppercase tracking-widest mb-3">Структура теста (85 вопросов)</h4>
            <ul className="space-y-2 text-sm font-semibold text-slate-600">
              <li className="flex justify-between"><span>📚 Русский язык</span> <span className="text-slate-900 font-black">30 вопр.</span></li>
              <li className="flex justify-between"><span>📐 Математика</span> <span className="text-slate-900 font-black">25 вопр.</span></li>
              <li className="flex justify-between"><span>🌍 Иностранный язык</span> <span className="text-slate-900 font-black">30 вопр.</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex gap-4">
          <button onClick={() => navigate('/')} className="px-6 py-4 rounded-xl font-bold text-slate-500 bg-slate-100 hover:bg-slate-200 transition-colors">
            Отмена
          </button>
          <button onClick={handleStartExam} className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-black py-4 rounded-xl shadow-lg shadow-blue-600/30 transition-all hover:-translate-y-1">
            Сформировать и начать
          </button>
        </div>

      </div>
    </div>
  );
}

export default GraduationExamSetup;